import { createReducer } from "reduxsauce"
import actionCreator from "helpers/actionCreator"
import { takeLatest, call, select, put } from "redux-saga/effects"
import { post as postApi, get as getApi } from "api"
import { Creators as notificationCreators } from "modules/notifications/model"
import { Creators as modelCreators } from "model/data"
import { size } from "lodash"

export const { Types, Creators } = actionCreator("ompnt/modules/alpha-theory/", {
  fetchFunds: [],
  fetchFundsSuccess: ["funds"],
  fetchFundsError: [],
  importFunds: {
    props: ["funds"],
    track: true,
    trackType: "alpha-theory-funds-import",
    trackPayload: ({ funds }) => ({ fundsCount: size(funds) }),
  },
  importFundsSuccess: [],
})

const INITIAL_STATE = {
  importing: false,
  authenticated: false,
  funds: {
    loading: false,
    items: [],
  },
}

function handleFetchFunds(state) {
  return { ...state, funds: { ...INITIAL_STATE.funds, loading: true } }
}

function handleFetchFundsSuccess(state, { funds }) {
  return { ...state, funds: { loading: false, items: funds } }
}

function handleFetchFundsError(state) {
  return { ...state, funds: { loading: false, items: false, error: true } }
}

function handleImportFunds(state) {
  return { ...state, importing: true }
}

function handleImportFundsSuccess(state) {
  return { ...state, importing: false }
}

export const HANDLERS = {
  [Types.FETCH_FUNDS]: handleFetchFunds,
  [Types.FETCH_FUNDS_SUCCESS]: handleFetchFundsSuccess,
  [Types.FETCH_FUNDS_ERROR]: handleFetchFundsError,
  [Types.IMPORT_FUNDS]: handleImportFunds,
  [Types.IMPORT_FUNDS_SUCCESS]: handleImportFundsSuccess,
}

export default createReducer(INITIAL_STATE, HANDLERS)

export function* fetchFundlist() {
  const { account } = yield select(state => ({
    account: state.global.selected.account,
  }))

  try {
    const funds = yield call(
      getApi,
      `/api/${account}/alphaTheory/funds`,
    )
    yield put({ type: Types.FETCH_FUNDS_SUCCESS, funds })
  } catch {
    yield put({ type: Types.FETCH_FUNDS_ERROR })
    yield put(notificationCreators.add("error", null, "An unexpected error occured while retrieving the fund list from Alpha Theory."))
  }
}

export function* importFunds({ funds }) {
  const { account } = yield select(state => ({
    account: state.global.selected.account,
  }))

  try {
    yield call(
      postApi,
      `/api/${account}/alphaTheory/import`,
      { funds },
    )
    yield put(modelCreators.resetCollections(["forecasts", "benchmarksAndPortfolios", "accountPortfolios", "portfolios", "experiments", "alphaTheoryMetadata"]))
    yield put({ type: Types.IMPORT_FUNDS_SUCCESS })
  } catch {
    yield put(notificationCreators.add("error", null, "An unexpected error occured while importing the funds from Alpha Theory."))
  }
}

export function* saga() {
  yield takeLatest(Types.FETCH_FUNDS, fetchFundlist)
  yield takeLatest(Types.IMPORT_FUNDS, importFunds)
}
